class AstStickyAtc extends HTMLElement {
  constructor() {
    super();
    this.btn = this.querySelector(".ast-sticky-atc__btn");
    this.form = this.querySelector(".ast-sticky-atc__form");
    this.hiddenInput = this.querySelector('[name="id"]');

    this.initObserver();
    this.initForm();
  }

  initObserver() {
    const targetElement =
      document.querySelector(".ast-cart-bar") ||
      document.querySelector('form[action^="/cart/add"]');

    if (!targetElement) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting && entry.boundingClientRect.bottom < 0) {
            this.classList.add("ast-sticky-atc--visible");
          } else {
            this.classList.remove("ast-sticky-atc--visible");
          }
        });
      },
      { rootMargin: "0px", threshold: 0 },
    );

    observer.observe(targetElement);
  }

  initForm() {
    this.form.addEventListener("submit", (e) => {
      e.preventDefault();

      const mainVariantInput = document.querySelector(
        'form[action^="/cart/add"] [name="id"]',
      );
      if (mainVariantInput) {
        this.hiddenInput.value = mainVariantInput.value;
      }

      const originalText = this.btn.textContent;
      this.btn.textContent = "...";
      this.btn.classList.add("loading");

      const formData = new FormData(this.form);

      fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        body: formData,
      })
        .then((response) => response.json())
        .then(() => {
          this.btn.textContent = "Added";
          setTimeout(() => {
            this.btn.textContent = originalText;
            this.btn.classList.remove("loading");
          }, 2000);

          document.documentElement.dispatchEvent(
            new CustomEvent("cart:updated", { bubbles: true }),
          );
          const cartDrawer = document.querySelector("cart-drawer");
          if (cartDrawer) cartDrawer.classList.add("active");
        })
        .catch(() => {
          this.btn.textContent = "Error";
          this.btn.classList.remove("loading");
        });
    });
  }
}

if (!customElements.get("ast-sticky-atc")) {
  customElements.define("ast-sticky-atc", AstStickyAtc);
}
